<div class="dialog-container">
    <div class="dialog-loader-overlay" *ngIf="loading">
        <kb-loader></kb-loader>
    </div>
    <div class="user-rights-title" style="background-color: #ededed;">
        <span class="order-text">{{'common.text_account_savedcart_restore_popuptitle'|cxTranslate}}</span>

        <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
            <img src="icons/close-light-grey.svg" alt="" width="25" />
        </button>
    </div>

    <mat-dialog-content class="saved-cart-dialog">
        <div id="cboxLoadedContent">
            <div id="popup_confirm_savedcart_delete_0007042281"
                class="js-savedcart_delete_confirm_modal savecart-delete">
                <p class="delete-savecart-value">
                    {{'common.text_account_savedcart_to_activecart'|cxTranslate}}
                </p>
                <div class="modal-details row">
                    <div class="col-xs-12 col-sm-12">
                        <span
                            class="delete-savecart-label"><strong>{{'common.text_account_savedcart_cart_name'|cxTranslate}}:&nbsp;</strong></span>
                        <span class="delete-savecart-value">{{_data.name}}</span>
                    </div>
                    <div class="col-xs-12 col-sm-12">
                        <span
                            class="delete-savecart-label"><strong>{{'common.text_account_savedCart_id'|cxTranslate}}:&nbsp;</strong></span>
                        <span class="delete-savecart-value">{{_data.id}}</span>
                    </div>
                    <div class="col-xs-12 col-sm-12">
                        <span
                            class="delete-savecart-label"><strong>{{'common.text_account_savedcart_numberofproducts'|cxTranslate}}:&nbsp;</strong></span>
                        <span class="delete-savecart-value">{{_data.positions}}</span>
                    </div>
                </div>

            </div>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="d-flex justify-content-end">
        <div class="d-flex action-btn row">

            <button class="btn delete-btn col-xs-12 col-sm-12" (click)="restore()">
                {{'common.text_account_savedcart_restore_btn'|cxTranslate}}<img class="hover-img"
                    src="/icons/link-grey.svg" alt="Link Icon">
            </button>

            <button class="btn cancel-btn col-xs-12 col-sm-12" (click)="cancel()">
                {{'common.text_account_quote_cancel'|cxTranslate}}
            </button>
        </div>
    </mat-dialog-actions>
</div>